import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { NewsroomCard } from "./NewsroomCard";

const meta: Meta<typeof NewsroomCard> = {
  title: "Newsroom card",
  component: NewsroomCard,
  decorators: [
    (Story) => (
      <div className="mx-auto max-w-100">
        <Story />
      </div>
    ),
  ],
};

export default meta;

export const Default: StoryObj<typeof NewsroomCard> = {
  args: {
    type: "Newsroom",
    newsroomType: "Award",
    date: "Mon, 12 Jan 2026 11:55:32 GMT",
    title: "Default eliminates tool sprawl and accelerates issue resolution.",
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
    },
  },
};

export const News: StoryObj<typeof NewsroomCard> = {
  args: {
    type: "Newsroom",
    newsroomType: "News",
    date: "Mon, 12 Jan 2026 11:55:32 GMT",
    title: "Default eliminates tool sprawl and accelerates issue resolution.",
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/fe7b05e6-0071-4571-a052-b2f1016afa54/Placeholder_image_Original%20file.png?disable=upscale&width=1024",
    },
  },
};
